import { registerCardTemplate } from "../../../common/common";
import { lazyTemplate } from "../../lazyTemplate";
import { generateIconProp } from "../../../common/icon-selector/IconEditor";

// Eager metadata registration; the render component (CustomUICard) code-splits
// into its own tpl-custom-ui-card chunk, loaded on demand when the widget renders.
registerCardTemplate({
    id: 'custom-ui-card',
    name: 'Custom Interface Card',
    description: 'Describe a custom interface in a markup language',
    template: lazyTemplate(() => import(/* webpackChunkName: "tpl-custom-ui-card" */ "./CustomUICard")),
    icon: generateIconProp('box'),
    complexity: 'easy',
});
